import { controls } from "../../controls";

const rp958 = {
  label: "FORM-I-ST Adv.Proposal",
  pageLabel: "FORM-I-ST Adv.Proposal",
  starting: true,
  url: "rp958",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab: "filter",label: "First Alternative Firday",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"alternative_firday_date",isRequired:true,width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({tab: "filter",label: "Second Alternative Friday",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"second_alternative_friday_date",isRequired:true,width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({tab: "filter",label: "Third Alternative Firday",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"third_alternative_friday_date",isRequired:true,width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-2" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form:[],

  history: {
    perPage: 10,
    reportHeader: "FORM-I-ST Adv.Proposal",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Sr.No.",
        accessor: "srno_code",
        width: 80,
        rwidth: 50

      },
      {
        Header: "Particulars",
        accessor: "particulars_name",
        width: "*",
        rwidth: "*"
      },
      
      {
        Header: "First Alternative Firday",
        accessor: "first_alter_friday_name",
        type:"currency",
        width: "*",
        rwidth: 50
      },
      {
        Header: "Second Alternative Firday",
        accessor: "second_alter_firday",
        type:"currency",
        width: "*",
        rwidth: 50
      },
      {
        Header: "Third Alternative Firday",
        accessor: "third_alter_firday",
        type:"currency",
        width: "*",
        rwidth: 50
      },

    ]
  }
};

export default rp958;